import { PrivacyPolicyPage } from "@/features/legal/privacy-policy.page";
import { createFileRoute } from "@tanstack/react-router";

// Public on purpose (outside `_authenticated`): the log-in / sign-up consent
// line, the AppFooter, the Terms of Use and the Atlassian Marketplace listing
// all link here (CR-265, CR-275).
export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicyPage,
});
